import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Picture } from 'src/components/Elements/Picture';
import htDoorHorizontalLogo from 'src/images/ht_door_horizontal_logo.svg';
import styles from './styles.scss';

const BookingHeaderLogo = ({ logo }) => (
  <div className={styles.logos}>
    <Picture src={htDoorHorizontalLogo} className={styles.htLogo} />
    {logo && (
      <div className={cn(styles.partnerLogoWrapper, 'marginLeft-small paddingLeft-small')}>
        <img src={logo} alt="Logo" />
      </div>
    )}
  </div>
);

BookingHeaderLogo.propTypes = {
  logo: PropTypes.string,
};

BookingHeaderLogo.defaultProps = {
  logo: null,
};

export default BookingHeaderLogo;
